import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import * as actTableManagement from 'actions/tableManagement';
import { formValueSelector } from 'redux-form';
import moment from 'moment';
import FilteredReport from './FilteredReport';
import styles from './style.css';

class List extends React.Component {
  render() {
    const { reportDetail, reports, summary } = this.props;
    return (
      reports &&
      reports.length > 0 && (
        <div className={styles.wrapper}>
          <div
            className={`${styles['summary-data-box']} visible-md visible-lg`}
          >
            <div className="row">
              <div className="col-xs-6">
                <div className={styles.amount}>{summary.completed}</div>
                <div className={styles['title-center']}>Completed Orders</div>
              </div>
              <div className="col-xs-6">
                <div className={styles.amount}>{summary.cancelled}</div>
                <div className={styles['title-center']}>Cancelled Orders</div>
              </div>
            </div>
          </div>

          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.name}>Date</th>
                <th className={styles.name}>Receipt Number</th>
                <th className={styles.name}>Served By</th>
                <th className={styles.name}>Pax</th>
                <th className={styles.name}>Duration</th>
                <th className={styles.name}>Status</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper-void-item']}>
            <InfiniteScroll
              pageStart={1}
              loadMore={this._onReachBottom}
              hasMore={this._hasMore()}
              useWindow={false}
              threshold={10}
              initialLoad={false}
            >
              <table className={styles['table-content']}>
                <tbody>
                  {reports.map(report => {
                    return (
                      <FilteredReport
                        key={report.id}
                        report={report}
                        reportDetail={reportDetail}
                        onClickRow={this._onClickRow}
                      />
                    );
                  })}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )
    );
  }

  _onClickRow = report => {
    const { dispatch } = this.props;
    dispatch(actTableManagement.onReportsClickRow(report));
  };

  _onReachBottom = () => {
    const { dispatch, currentPage, reports } = this.props;
    const { startHour, endHour, allDay } = this.props.search.date;
    let { startDate, endDate } = this.props.search.date;
    const { statusIds } = this.props.search;

    if (!allDay) {
      startDate = `${moment(startDate).format(`YYYY-MM-DD ${startHour}:00`)}`;
      endDate = `${moment(endDate).format(`YYYY-MM-DD ${endHour}:00`)}`;
    } else {
      startDate = `${moment(startDate).format('YYYY-MM-DD 00:00:00')}`;
      endDate = `${moment(endDate).format('YYYY-MM-DD 23:59:59')}`;
    }

    dispatch(
      actTableManagement.reportsRequest({
        page: currentPage + 1,
        statusIds,
        startDate: moment(startDate).format(), // need to format time with timezone 2019-06-24T09:00:00+07:00
        endDate: moment(endDate).format(),
        previousReports: reports,
      })
    );
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };
}

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const {
    currentPage,
    totalPage,
    reportDetail,
    reports,
    summary,
  } = state.tableManagement.report;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    search: {
      outletIds: selector(state, 'outletIds'),
      date: selector(state, 'date'),
      statusIds: selector(state, 'statusIds'),
    },
    reports,
    currentPage,
    totalPage,
    reportDetail,
    showLoadingSpinnerPage,
    summary,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

List.propTypes = {
  dispatch: PropTypes.func,
  reports: PropTypes.array,
  reportDetail: PropTypes.object,
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);
